export const attach = () => {}



// WEBPACK FOOTER //
// ./src/components/_modules/Payment/override.js